import { Link } from 'react-router-dom'
import { getAllFlavors, sizeOptions } from '../../utils/constants'
import { getCakeImage } from '../cake-builder/ui'

// The cakes the hero copy calls crowd favourites, plus two classics.
const FAVOURITE_IDS = ['rasmalai', 'gulab-jamun', 'black-forest', 'tiramisu']

function FavouritesSection() {
  const flavours = getAllFlavors()
  const items = FAVOURITE_IDS.map((id) => {
    const f = flavours.find((x) => x.id === id)
    return {
      ...f,
      img: getCakeImage(id),
      from: f.priceCategory === 'classic' ? sizeOptions[0].priceClassic : sizeOptions[0].pricePremium,
    }
  })

  return (
    <section className="bg-peach-50">
      <div className="container mx-auto px-4 pt-8 pb-5 md:py-14 max-w-6xl">
        <div className="flex items-baseline justify-between gap-3 mb-4 md:mb-6">
          <h2 className="text-[26px] md:text-4xl">Customer favourites</h2>
          <Link to="/menu" className="text-sm md:text-base font-semibold text-coral-600 whitespace-nowrap min-h-[44px] inline-flex items-center">
            Full menu
          </Link>
        </div>
        <div className="flex gap-3 overflow-x-auto snap-x snap-mandatory scrollbar-none -mx-4 px-4 py-1.5 md:grid md:grid-cols-4 md:gap-5 md:overflow-visible md:mx-0 md:px-0">
          {items.map((f) => (
            <Link
              key={f.id}
              to={`/cake-builder?flavor=${f.id}`}
              className="snap-start shrink-0 w-[150px] md:w-auto rounded-xl border-2 border-gray-200 bg-white p-1.5 hover:border-coral-300 transition-colors"
            >
              <img src={f.img.image} alt={f.img.altText || f.name} loading="lazy" className="w-full h-28 md:h-44 object-cover rounded-[12px]" />
              <div className="px-1.5 pt-2 pb-1">
                <div className="text-sm md:text-base font-semibold text-charcoal">{f.name.replace(' Cake', '')}</div>
                <div className="text-xs md:text-sm text-gray-500">from €{f.from}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FavouritesSection
